export const pencilIcon = () => ({
    height: '1.25rem',
});
